const initDecentMode = () => {

    const button = document.querySelector('#decent-mode-switch:not(.initialised)');

    if(!button){
        return;
    }

    if(isDecentModeOn()){
        setDecentModeOn();
    }
    else{
       setDecentModeOff();
    }

    button.addEventListener('click', function(e) {
        e.preventDefault();
        toggleDecentMode()
    });
    button.classList.add('initialised');


    displayShortcut()
    document.addEventListener('keydown', function (e) {
        if (e.metaKey && e.key === 'b') { // Detect Cmd + B
            e.preventDefault();
            toggleDecentMode();
        }
    });
}

const toggleDecentMode = () => {
    if (isDecentModeOn()) {
        setDecentModeOff();
    } else {
        setDecentModeOn();
    }
}
const isDecentModeOn = () => {
    return localStorage.getItem('decent-mode') === 'on';
}
const setDecentModeOn = () => {
    const button = document.querySelector('#decent-mode-switch');
    const buttonText = button.querySelector('.decent-mode-text');

    localStorage.setItem('decent-mode', 'on');
    document.body.setAttribute('data-decent-mode', 'on');
    buttonText.innerHTML = button.getAttribute('data-off-title');
}
const setDecentModeOff = () => {
    const button = document.querySelector('#decent-mode-switch');
    const buttonText = button.querySelector('.decent-mode-text');

    localStorage.setItem('decent-mode', 'off');
    document.body.setAttribute('data-decent-mode', 'off');
    buttonText.innerHTML = button.getAttribute('data-on-title');
}

const displayShortcut = () => {
    const button = document.querySelector('#decent-mode-switch');


    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    let isMac = false;
    if (navigator.userAgentData && navigator.userAgentData.platform) {
        isMac = navigator.userAgentData.platform === 'macOS';
    } else {
        isMac = /Mac/i.test(navigator.userAgent);
    }

    // Pokud to není mobil, nastav zkratku
    if (!isMobile) {
        const shortcutSpan = button.querySelector('.decent-mode-shortcut');
        const shortcutText = isMac ? '(⌘+B)' : '(Ctrl+B)';
        shortcutSpan.textContent = shortcutText;
    }

}

export default initDecentMode;